/* eslint-disable react-hooks/exhaustive-deps */

import { Flex } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { fetchAPI } from '@/api/fetch';
import { apiGetClient } from '@/api/services';
import { useCreateJob } from '@/store/createJob';
import { Stepper } from '@/types/enums';

import AIAnalysis from './AIAnalysis';
import EditJobDetails from './EditJobDetails';
import Review from './Review';
import SearchClient from './SearchClient';
import Success from './Success';
import CreateJobProgress from './CreateJobProgress';

export default function CreateJob() {
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get('client_id');
  const createJobStore = useCreateJob();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeJobCreation = async () => {
      setIsLoading(true);
      createJobStore.reset();

      if (clientId) {
        try {
          const response = await fetchAPI<Client>({
            request: () => apiGetClient(clientId)
          });

          if (response.success) {
            createJobStore.setSelectedClient(response.data);
            createJobStore.setCurrentPage(Stepper.JobDetails);
            createJobStore.setStep(Stepper.JobDetails);
          } else {
            console.error('Failed to fetch client:', response.message);
          }
        } catch (error) {
          console.error('Failed to fetch client:', error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    initializeJobCreation();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [createJobStore.currentPage]);

  return (
    <Flex w="100%" flexDir="column" p="40px 48px">
      <Flex flexDir="column" justifyContent="center">
        <CreateJobProgress isLoading={isLoading} />
        {(() => {
          switch (createJobStore.currentPage) {
            case Stepper.Client:
              return <SearchClient />;
            case Stepper.JobDetails:
              return <EditJobDetails />;
            case Stepper.AiAnalysis:
              return <AIAnalysis />;
            case Stepper.Review:
              return <Review />;
            case Stepper.Success:
              return <Success />;
            default:
              return null;
          }
        })()}
      </Flex>
    </Flex>
  );
}
